module.exports = __webpack_public_path__ + "img/envelope2.947ee27a.jpg";